const easing = [0.6, -0.05, 0.01, 0.99];

const animHeading = {
  hidden: { opacity: 0, y: -50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easing } },
};

const animPost = {
  hidden: { opacity: 0, x: -150 },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, type: "tween" } },
};

const animTitles = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 1},
  },
};

const slideOne = {
  hidden: { x: 0 },
  show: { x: -1000, transition: { duration: 2, type: "tween" } },
};

const slideTwo = {
  hidden: { x: 0 },
  show: { x: 1000, transition: { duration: 2, type: "tween" } },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 1, ease: easing } },
};

export { animHeading, animPost, animTitles, slideOne, slideTwo, fadeInUp };
